// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"163df3ca","322":"172079e4","361":"663b9b97","415":"75a5e0ad","615":"5c37d090","891":"67b3c587"}[chunkId] + ".chunk.js";
};